import { COMMANDERS } from './../../../c.managers/LevelManager/store.d'
import { WEAPONS } from './../../../f.assets/Characters/scripts/constants'
import { AnimationAction, AnimationMixer, Object3D } from 'three'
import CharacterAnimator from '../../../d.controllers/AnimationController/scripts/characterAnimator'
import { Characters } from '../../../d.controllers/CharactersController'
import { GLTFActions } from '../../../f.assets/animations/CharactersAnimations'
import { CHARACTER_STATES } from '../../../f.assets/Characters/scripts/constants'
import Interactive from './Interactive'
import { GAME_OBJECTS } from './types'

export default class Character extends Interactive {
  animationMixer: AnimationMixer
  currentActionName?: keyof GLTFActions
  currentAction?: AnimationAction
  animator: CharacterAnimator
  prevOwner?: COMMANDERS
  isDead?: boolean

  constructor(obj: Object3D) {
    super(obj)
    this.types.push(GAME_OBJECTS.CHARACTER)
    this.animationMixer = new AnimationMixer(this.obj)
    this.animator = new CharacterAnimator(this)
  }

  get state() {
    return Characters.getState(this.uuid)?.state as CHARACTER_STATES
  }

  get owner() {
    return Characters.getState(this.uuid).owner
  }

  set owner(newOwner: COMMANDERS | undefined) {
    this.prevOwner = this.owner
    Characters.updateState(this.uuid, {
      owner: newOwner ?? COMMANDERS.NOBODY,
    })
  }

  get hp() {
    return Characters.getState(this.uuid).hp || 0
  }
  set hp(newHP: number) {
    Characters.updateState(this.uuid, {
      hp: newHP,
    })
  }
  set weapon(weapon: WEAPONS | undefined) {
    Characters.updateState(this.uuid, {
      weapon,
    })
  }
  get hp_max() {
    return Characters.getState(this.uuid).hp_max || 0
  }
  get tickDivisions() {
    return this.obj.userData.tickDivisions as number[]
  }
  get variant() {
    return Characters.getState(this.uuid).variant
  }
  get isAlive() {
    return ![CHARACTER_STATES.DEAD, CHARACTER_STATES.INACTIVE].includes(this.state) && this.hp > 0 && !this.isDead
  }
}
